import React, { Component } from 'react';
import { Router, Route } from 'react-router-dom';

import TimeOut from './components/TimeOut/TimeOut';

import ProgressBar from './containers/ProgressBar/ProgressBar';
import Help from './containers/Help/Help';
import Home from './containers/Home/Home';
import GetStarted from './containers/GetStarted/GetStarted';
import RatesFees from './containers/RatesFees/RatesFees';
import Name from './containers/PersonalInfo/Name/Name';
import Birthdate from './containers/PersonalInfo/Birthdate/Birthdate';
import Contact from './containers/PersonalInfo/Contact/Contact';
import Address from './containers/PersonalInfo/Address/Address';
import LivingSituation from './containers/PersonalInfo/LivingSituation/LivingSituation';
import Occupation from './containers/Occupation/Occupation';
import IncomeExpenses from './containers/IncomeExpenses/IncomeExpenses';
import IncomeFinances from './containers/IncomeExpenses/IncomeFinances';
import AuthorizedUsers from './containers/AuthorizedUsers/AuthorizedUsers';
import AddAuthorizedUsers from './containers/AddAuthorizedUsers/AddAuthorizedUsers';
import BalanceProtection from './containers/BalanceProtection/BalanceProtection';
import Review from './containers/Review/Review';
import ConfirmIdentity from './containers/ConfirmIdentity/ConfirmIdentity';
import Submit from './containers/Submit/Submit';
import WhatsNext from './containers/WhatsNext/WhatsNext';
import TimeOutContainer from './containers/TimeOut/TimeOut';
import Error from './containers/Error/Error';

import RouteRedirect from './containers/RouteRedirect/RouteRedirect';

import { GetAnalytics } from './utils/ApplicationApi';

import ReactGA from 'react-ga';
import { createBrowserHistory } from 'history';

import TagManager from 'react-gtm-module';

const history = createBrowserHistory();

GetAnalytics().then(result => 
  {
    ReactGA.initialize(result);
  }
  ).catch(error => {
    console.log("Failed to get GA tracking code. GA is not initialized.")
  })

history.listen((location) => {
    ReactGA.pageview(location.pathname);
    console.log(location.pathname)
});

const tagManagerArgs = {
  gtmId: 'GTM-5H6ZWL3'
}

TagManager.initialize(tagManagerArgs)

class App extends Component {
  //PBI 441343: Extracting UTM parameters from query string in the URL at the start of an application and storing it in session storage (temporary)
  componentDidMount() {
    const locationSearchParams = new URLSearchParams(window.location.search);
    const utmParams = {
      utmSource: locationSearchParams.get('voa_source') || '',
      utmMedium: locationSearchParams.get('voa_medium') || '',
      utmCampaign: locationSearchParams.get('voa_campaign') || '',
      utmContent: locationSearchParams.get('voa_content') || '',
    }
    sessionStorage.setItem('utmParams', JSON.stringify(utmParams));
    //Including UTM Params for Google Analytics
    TagManager.dataLayer({
      dataLayer: {
        pageCategory: 'Start Credit Card Application',
        event: 'Credit Card Landing Page',
        ...utmParams,
      },
    });
  }

  render() {    
    return (
      <div className="App">    
          <Help />
          <Router history={history}>
            <div>
              <RouteRedirect />
              <TimeOut />
              <ProgressBar />  
              <div className="content-container">
                <Route exact path="/" component={Home} />
                <Route exact path="/Card/:tpc?/:cpc?/:offerCode?" component={Home} />
                <Route exact path="/GetStarted" component={GetStarted} />
                <Route exact path="/RatesFees" component={RatesFees} />
                <Route exact path="/PersonalInfo/Name" component={Name} />
                <Route exact path="/PersonalInfo/Birthdate" component={Birthdate} />
                <Route exact path="/PersonalInfo/Contact" component={Contact} />
                <Route exact path="/PersonalInfo/Address" component={Address} />
                <Route exact path="/PersonalInfo/LivingSituation" component={LivingSituation} />
                <Route exact path="/Occupation" component={Occupation} />
                <Route exact path="/IncomeExpenses" component={IncomeExpenses} />
                <Route exact path="/IncomeExpenses/Finances" component={IncomeFinances} />
                <Route exact path="/AuthorizedUsers" component={AuthorizedUsers} />
                <Route exact path="/AuthorizedUsers/Add" component={AddAuthorizedUsers} />
                <Route exact path="/Bpi" component={BalanceProtection} />
                <Route exact path="/Review" component={Review}/>
                <Route exact path="/Review/ConfirmIdentity" component={ConfirmIdentity} />
                <Route exact path="/Submit" component={Submit} />
                <Route exact path="/WhatsNext" component={WhatsNext} />
                <Route exact path="/TimeOut" component={TimeOutContainer} />
                <Route exact path="/Error" component={Error} />
              </div>
            </div>
          </Router>        
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js